export type BusinessCategory = {
  id?: number;
  name?: string;
  iconUrl?: string;
  active?: boolean;
  companyId?: number;
};
